var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"dark":"","right":"","color":"#9ea7b4"},on:{"click":_vm.copyText}},[_vm._v(" mdi-content-copy ")])
}
var staticRenderFns = []

export { render, staticRenderFns }